var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var SendIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 64
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM24.0907 45.7409C23.6876 45.9497 23.3025 46.0011 22.9175 45.9999C21.6575 45.9962 20.6454 45.0132 20.6498 43.5257L22.2111 36.3114C22.2137 35.4189 22.8805 34.7909 23.7556 34.776L35.1174 33.3484C35.8349 33.333 40.0615 32.768 40.0636 32.0505C40.0657 31.333 35.8426 30.743 35.1251 30.7234L23.6698 28.8212C22.7948 28.8011 22.1317 28.1691 22.1343 27.2766L20.7178 20.4783C20.7222 18.9908 21.7401 17.9963 23.0001 18C23.3676 18.0011 23.7699 18.0723 24.1718 18.2835L47.2719 30.1467C48.0582 30.5516 48.6863 31.1834 48.6837 32.0759C48.681 32.9684 48.0492 33.5965 47.2605 33.9967L24.0907 45.7409Z",
    fill: "black"
  }));
};
export var SendIconGlyph = function (props) {
  return React.createElement(SendIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};